import Base from './base'
import urls from 'config/urls'

class Brand extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.brand.find,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.brand.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.brand.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.brand.delete,
      data: opts
    })
  }
}

export default new Brand



// WEBPACK FOOTER //
// ./src/models/brand.js